// extracted by mini-css-extract-plugin
module.exports = {"title":"Progress_title__19jdl","days":"Progress_days__1UPHK","total":"Progress_total__38gCQ","points":"Progress_points__t9GSf"};